import { render, staticRenderFns } from "./RadioCom.vue?vue&type=template&id=f5f97c42&scoped=true&"
import script from "./RadioCom.vue?vue&type=script&lang=js&"
export * from "./RadioCom.vue?vue&type=script&lang=js&"
import style0 from "./RadioCom.vue?vue&type=style&index=0&id=f5f97c42&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f5f97c42",
  null
  
)

export default component.exports